import { IDataRow } from "pages/meter/types";
import { DataRow } from "pages/meter/components";
type IListProps = {
  dataList: IDataRow[];
};

export const List = ({ dataList }: IListProps) => {
  return (
    <>
      {dataList.map((item) => (
        <div className="pt-3">
          <DataRow key={item.id} data={item} />
        </div>
      ))}
    </>
  );
};
